"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_BLOCK_HEIGHT_FAIL = void 0;
exports.GET_BLOCK_HEIGHT_FAIL = 'Error fetching block height for timestamp';
